import api from "./api";
import dayjs from "dayjs";

export const getSystemBattery = async () => {
  const res = await api.get("/apis/system_battery");
  return res.data;
};

// Accountability as a series (one row per day by default), the same call the
// Analytics -> Flow Analytics Accountability tab makes.
// system: "total" | "potable" | "non_potable"
// range: { start, end } ("YYYY-MM-DD", end inclusive) with option "Custom".
export const getAccountabilitySeries = async (
  system = "total",
  option = "Past Week",
  interval = "Days",
  number = 1,
  range = null,
) => {
  const res = await api.get("apis/accountability", {
    params: {
      option,
      interval,
      number,
      system,
      class_code: "ALL",
      ...(range ? { start_date: range.start, end_date: range.end } : {}),
    },
  });
  return res.data; // { data: { accountability_data, accountability_with_maintainance_and_temp_meter_data, ... } }
};

export const getAccountabilityDashboard = async (value) => {
  const res = await api.get("apis/accountability_dashboard", {
    params: { option: value },
  });
  return res.data;
};

// export const getFlowHealth = async () => {
//   const res = await api.get("/apis/flow_health");
//   return res.data;
// };
export const getFlowHealth = async (category) => {
  const res = await api.get("/apis/flow_health", {
    params: category && category !== "ALL" ? { Category: category } : {},
  });

  return res.data;
};

export const getSystemUsage = async (days) => {
  const res = await api.get(`apis/system_usage`, {
    params: {
      option: days,
    },
  });
  return res.data;
};

export const getTrendData = async (option, start, end, startWeek, endWeek) => {
  const params = {
    option_value: option,
    start,
    end,
  };

  // Keep existing week params for other filters only
  // Quarter API needs only: option_value, start, end
  if (option !== "Quarter") {
    params.start_week = startWeek ?? "undefined";
    params.end_week = endWeek ?? "undefined";
  }

  const res = await api.get(`apis/trend`, { params });
  return res.data;
};

// 2. Fetch Individual Account/Meter Trend Data
// export const getAccountTrend = async (
//   option,
//   start,
//   end,
//   startWeek,
//   endWeek,
//   meterIds,
// ) => {
//   const res = await api.get(`apis/account_trend`, {
//     params: {
//       option_value: option,
//       start,
//       end,
//       start_week: startWeek,
//       end_week: endWeek,
//       meterid: JSON.stringify(meterIds), // API expects a JSON string of IDs
//     },
//   });
//   return res.data;
// };

export const getAccountTrend = async (
  option,
  start,
  end,
  startWeek,
  endWeek,
  meterIds,
) => {
  const params = {
    option_value: option,
    start,
    end,
    meterid: JSON.stringify(meterIds),
  };

  if (option !== "Quarter") {
    params.start_week = startWeek;
    params.end_week = endWeek;
  }

  const res = await api.get(`apis/account_trend`, { params });
  return res.data;
};

export const getDownloadAccountTrend = async (option, start, end, meterIds) => {
  const res = await api.get("apis/download_account_trend", {
    params: {
      option_value: option,
      start: start,
      end: end,
      start_week: undefined, // Matches your requested URL structure
      end_week: undefined,
      meterid: JSON.stringify(meterIds), // Encodes ["288433-"]
    },
  });
  return res.data;
};

export const getAccountOverrideSelect = async (selectedIds) => {
  const res = await api.get("apis/meter/account_override/select", {
    params: {
      selected: JSON.stringify(selectedIds), // Encodes ["429700"]
    },
  });
  return res.data;
};

export const getAccountOverrideList = async () => {
  const res = await api.get("apis/account/overide_name/select/list");
  return res.data;
};
export const getTwinStats = async () => {
  const res = await api.get("/apis/meter_stat_operational/count");
  return res.data;
};
// Account settings apis
export const getAdminSettingsList = async (district) => {
  const res = await api.get(`apis/admin_settings/all_list`, {
    params: { district }, // remove if API does not require district
  });
  return res.data;
};

// ✅ CREATE
export const createSettingsParameters = async (data) => {
  try {
    const res = await api.post("apis/admin_settings", data);
    console.log("Create Admin Setting Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error creating admin setting:", error);
    throw error;
  }
};

export const deleteAdminSetting = async (id) => {
  console.log("deleteid", id);
  const res = await api.delete(`apis/admin_settings/${id}`);
  return res.data;
};

export const editAdminSetting = (id, payload) => {
  console.log("editidddd", id);
  return api.put(`apis/admin_settings_edit/${id}`, payload);
};

export const getUserList = async (district) => {
  try {
    // GET request to fetch user data from the API endpoint, passing the district parameter
    const res = await api.get("apis/user_list", {
      params: { district }, // Include district in the API request
    });
    // console.log("User List Response:", res);
    return res.data; // Assuming the response contains an array of users
  } catch (error) {
    console.error("Error fetching user list:", error);
    throw error; // Propagate error if needed
  }
};

export const getOverrideAccountsList = async () => {
  try {
    // If district is not required, just call the API without params
    const res = await api.get("apis/account/overide_name/list");

    // console.log("Override Name List Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching override name list:", error);
    throw error;
  }
};

export const getMeterManagement = async () => {
  try {
    // If district is not required, just call the API without params
    const res = await api.get("apis/account_based_meter_log_list");

    return res.data;
  } catch (error) {
    console.error("Error fetching meter management data:", error);
    throw error;
  }
};

// meterhistory

export const getChangeLog = () => {
  return api.get("apis/changelog");
};

export const getEntityChangeLog = (entityType, pk) => {
  console.log("Fetching changelog for entity:", entityType, "with PK:", pk);
  return api.get(`apis/changelog/entity?entity_type=${entityType}&pk=${pk}`);
};

export const getTwinMeter = async ({
  page = 1,
  page_limit = 50,
  active = "all",
}) => {
  const res = await api.get("/apis/meter_list", {
    params: { page, page_limit, active },
  });
  return res.data;
};
// --- Meters By Flow APIs (New Integration) ---

/**
 * Fetch the list of meters categorized by flow
 * @param {string} option - 'Day', 'Week', 'Hour', etc.
 * @param {string} rangeOption - 'Past Month', 'Past Week', etc.
 * @param {string|number} userId - The current user ID
 * @param {string} start - Custom start date (optional)
 * @param {string} end - Custom end date (optional)
 */
export const getMetersByFlowList = async (
  option,
  rangeOption,
  userId,
  start,
  end,
) => {
  const res = await api.get(`apis/water/aggregate/by_flow/meter_list`, {
    params: {
      option,
      range_option: rangeOption,
      user_id: userId,
      start: start || undefined,
      end: end || undefined,
    },
  });
  return res.data;
};

/**
 * Fetch chart trend data for selected meters
 * @param {string} option - 'Day', 'Week', 'Hour', etc.
 * @param {string} rangeOption - 'Past Month', 'Past Week', etc.
 * @param {number} interval - Numerical interval (1, 2, etc.)
 * @param {Array} selectedMeters - Array of objects [{code, meters: []}]
 * @param {string} start - Custom start date (optional)
 * @param {string} end - Custom end date (optional)
 */
export const getMetersByFlowChart = async (
  option,
  rangeOption,
  interval,
  selectedMeters,
  start,
  end,
) => {
  const res = await api.post(
    `apis/water/aggregate/by_flow`,
    { selected_meters: selectedMeters }, // Request Body
    {
      params: {
        option,
        range_option: rangeOption,
        interval,
        start: start || undefined,
        end: end || undefined,
      },
    },
  );
  return res.data;
};

export const getAggregateAccount = async (
  option,
  rangeOption,
  interval,
  selected,
) => {
  const res = await api.get(`apis/water/aggregate/account`, {
    params: {
      option,
      range_option: rangeOption,
      interval,
      selected: JSON.stringify(selected), // API expects a JSON string of account names
    },
  });
  return res.data;
};

/**
 * Fetch aggregate data by Category (POST)
 */
export const getAggregateCategory = async (
  option,
  rangeOption,
  interval,
  paramsDatas,
) => {
  const res = await api.post(`apis/water/aggregate/category`, paramsDatas, {
    params: {
      option,
      range_option: rangeOption,
      interval,
    },
  });
  return res.data;
};

/**
 * Fetch user-specific color preferences
 */
export const getUserColors = async (userId) => {
  const res = await api.get(`apis/user_color`, {
    params: { user_id: userId },
  });
  return res.data;
};
// Ouliners

// Change all Outlier services to this pattern:
export const getOutliers = async (params) => {
  const res = await api.get(`apis/outliers/new`, {
    params: params, // This passes everything: option, minimum_score, start_date, end_date, etc.
  });
  return res.data;
};

export const getOutliersByMeter = async (params) => {
  const res = await api.get(`apis/outliers_by_meter/new`, {
    params: params,
  });
  return res.data;
};

export const getOutliersOverTime = async (params) => {
  const res = await api.get(`apis/outliers_time/new`, {
    params: params,
  });
  return res.data;
};

export const getOutliersCount = async (params) => {
  const res = await api.get(`apis/outliers_count/new`, {
    params: params,
  });
  return res.data;
};
// Notification
export const getNotificationStatusList = async ({ user_id, district }) => {
  const res = await api.get("/apis/notification_status_list", {
    params: { user_id, district },
  });
  return res.data;
};

//Reports and alerts
export const getNotificationMeterSettingsList = async (userId) => {
  const res = await api.get(`/apis/notification_meter_settings_list`, {
    params: { user_id: userId },
  });
  return res.data;
};

export const getUserNotificationSettings = async (userId) => {
  const res = await api.get(`/apis/user_notified/list`, {
    params: { user_id: userId },
  });
  return res.data;
};

// export const updateUserNotificationSetting = async (userId, option, value) => {
//   const res = await api.post(`/apis/user_notified`, null, {
//     params: {
//       user_id: userId,
//       option,
//       value,
//     },
//   });
//   return res.data;
// };
export const updateUserNotificationSetting = async (
  userId,
  option,
  value,
  types,
) => {
  const res = await api.post("/apis/user_notified", null, {
    params: {
      user_id: userId,
      option,
      types,
      value,
    },
  });
  return res.data;
};

export const addNotificationMeter = async ({
  user_id,
  weekly,
  monthly,
  meter_id,
  account_name,
  end_date,
  register_number,
}) => {
  const res = await api.post("/apis/notification_meters_main_update", null, {
    params: {
      user_id,
      weekly,
      monthly,
      meter_id,
      account_name,
      end_date,
      register_number,
    },
  });

  return res.data;
};

export const updateNotificationMeter = async ({
  user_id,
  weekly,
  monthly,
  meter_id,
  account_name,
  end_date,
  register_number,
}) => {
  const res = await api.post("/apis/notification_meters_main_update", null, {
    params: {
      user_id,
      weekly,
      monthly,
      meter_id,
      account_name,
      end_date, // we will send "YYYY-MM-DD 00:00:00"
      register_number,
    },
  });

  return res.data;
};

export const deleteNotificationMeter = async ({
  user_id,
  meter_id,
  register_number,
}) => {
  const res = await api.delete("/apis/notification_meters_remove", {
    params: {
      user_id,
      meter_id,
      register_number,
    },
  });

  return res.data;
};

// ✅ Water Usage Report Download API
export const getWaterUsageReport = async ({
  start_date,
  end_date,
  aggregate_on,
}) => {
  const res = await api.get("/apis/water_usage_report", {
    params: {
      report_range: "all",
      start_date,
      end_date,
      aggregate_on,
    },
  });

  return res.data;
};

export const getTotalConsumption = async (timeRange) => {
  const res = await api.get("/apis/all_year_consumption", {
    params: { option: timeRange },
  });
  return res.data;
};

export const getCapacityPlanning = async (unit) => {
  const res = await api.get(`/apis/capactiy`, {
    params: { unit },
  });
  return res.data;
};

export const getAccountBasedMetersList = async (userId) => {
  const res = await api.get("/apis/accountbased_meters_list", {
    params: { user_id: userId },
  });
  return res.data;
};

// ✅ USER SIGNUP
export const signupUser = async (data) => {
  try {
    const res = await api.post("apis/signup", data);
    console.log("Signup Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error signing up user:", error);
    throw error;
  }
};

// ✅ EDIT USER
export const editUser = async (id, data) => {
  try {
    const res = await api.put(`apis/signup/edit/${id}`, data);
    console.log("Edit User Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error editing user:", error);
    throw error;
  }
};
// DELETE USER

export const deleteUser = async (id) => {
  try {
    const res = await api.delete(`apis/delete_user/${id}`);
    console.log("Delete User Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
// ✅ PASSWORD RESET
// ✅ PASSWORD RESET (FIXED)
export const resetUserPassword = async (data) => {
  try {
    const res = await api.post("apis/admin_change_password", data);
    console.log("Reset Password Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

// ================= PROFILE SETTINGS APIs =================

//  Get User Profile
export const getUserProfile = async (userId) => {
  const res = await api.get("apis/user_profile", {
    params: { user_id: userId },
  });
  return res.data;
};

//  Get Color Palettes
export const getColorList = async () => {
  const res = await api.get("apis/color/list");
  return res.data;
};

//  Update Profile Details
export const updateUserProfile = async (data) => {
  const res = await api.post("apis/user_edit_profile", data);
  return res.data;
};

//  Change Password
export const changeUserPassword = async (data) => {
  const res = await api.put("apis/change_password", data);
  return res.data;
};

//  Change Email
export const changeUserEmail = async (oldEmail, newEmail) => {
  const res = await api.post("apis/change_email", null, {
    params: {
      old_email: oldEmail,
      email: newEmail,
    },
  });
  return res.data;
};

// Confirm Email OTP
export const confirmUserEmailOtp = async (data) => {
  const res = await api.post("apis/change_email_otp_confirm", data);
  return res.data;
};
/**
 * Fetch anomaly widget summary data
 * @param {string} timeRange - 'last_7_days', 'last_30_days', 'last_90_days', etc.
 */
export const getAnomalySummary = async (timeRange) => {
  const res = await api.get("apis/anomaly_widget_summary", {
    params: {
      time_range: timeRange,
    },
  });
  return res.data;
};

/**
 * Fetch anomaly meters (same endpoint as Analytics -> Anomaly Detection)
 * @param {string} category - 'ALL' or a category display name
 * @param {string} timeRange - 'last_30_days', 'Custom', etc.
 * @param {string} startDate - YYYY-MM-DD, only for 'Custom'
 * @param {string} endDate - YYYY-MM-DD, only for 'Custom'
 */
export const getAnomalyDetection = async (
  category = "ALL",
  timeRange = "last_30_days",
  startDate = null,
  endDate = null,
) => {
  const res = await api.get("apis/anoamaly_detection", {
    params: {
      category,
      time_range: timeRange,
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
    },
  });
  return res.data;
};

/**
 * Fetch the daily anomaly history of specific meters (the series behind the
 * Analytics -> Anomaly Detection chart)
 * @param {Array} meterIds - meter ids to load
 * @param {string} timeRange - 'last_30_days', 'last_90_days', etc.
 */
export const getAnomalyMeterHistory = async (meterIds, timeRange = "last_30_days") => {
  const res = await api.get("apis/anoamaly_detection", {
    params: {
      category: "ALL",
      meter_id: meterIds.join(","),
      time_range: timeRange,
    },
  });
  return res.data; // [ { meter_id, override_name, total_flow, data: [ ...day ] } ]
};

export const getWaterLeak = async (
  category = "ALL",
  interval = "Current",
  view = null,
  startDate = null,
  endDate = null,
  meterId = null,
) => {
  const res = await api.get("/apis/get_water_leak", {
    params: {
      category,
      interval,
      // "details" -> meter-level rows even for category=ALL (Leak Flow page)
      ...(view ? { view } : {}),
      // Custom interval needs an explicit date range.
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
      // Meter search -> server-side lookup by meter id (across all categories).
      ...(meterId ? { meter_id: meterId } : {}),
    },
  });
  return res.data;
};

// getWaterLeakCategories
export const getWaterLeakCategory = async () => {
  const res = await api.get("/apis/get_water_leak");
  return res.data;
};


// Get Leak Rate List
export const getWaterRate = async (page = 1, perPage = 5) => {
  const response = await api.get(
    `/apis/get_water_rate?page_no=${page}&records_per_page=${perPage}`,
  );
  return response.data;
};
// Add Leak Rate
export const addWaterRate = async (data) => {
  try {
    const response = await api.post("/apis/add_water_rate", data);
    return response.data;
  } catch (error) {
    console.error("Error adding water rate:", error);
    throw error;
  }
};
// Edit Leak Rate
export const editWaterRate = async (id, data) => {
  try {
    const response = await api.put(`/apis/edit_water_rate/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error editing water rate:", error);
    throw error;
  }
};
// Delete Leak Rate
export const deleteWaterRate = async (id) => {
  try {
    const response = await api.delete(`/apis/delete_water_rate/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting water rate:", error);
    throw error;
  }
};

// export const getMaintenanceLogs = async (
//   page = 1,
//   perPage = 5,
//   filters = {},
// ) => {
//   let url = `/apis/leak_maintenance?page=${page}&per_page=${perPage}`;

//   if (filters.option) {
//     url += `&option=${filters.option}`;
//   }

//   if (filters.start_date && filters.end_date) {
//     url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
//   }

//   const res = await api.get(url);
//   return res.data;
// };
export const getMaintenanceLogs = async (
  page = 1,
  perPage = 5,
  filters = {},
  recordType = "Maintenance",
) => {
  let url = `/apis/leak_maintenance?page=${page}&per_page=${perPage}`;

  if (recordType) {
    url += `&record_type=${recordType}`;
  }

  if (filters.option) {
    url += `&option=${filters.option}`;
  }

  if (filters.start_date && filters.end_date) {
    url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
  }

  // 🔥 PASS THE SEARCH QUERY TO THE BACKEND
  if (filters.search && filters.search.trim() !== "") {
    url += `&search=${encodeURIComponent(filters.search.trim())}`;
  }

  // 🔥 ADD THIS TO PASS SORT PARAMETERS TO THE BACKEND
  if (filters.sort_by) {
    url += `&sort_by=${encodeURIComponent(filters.sort_by)}&sort_order=${encodeURIComponent(filters.sort_order || "desc")}`;
  }

  const res = await api.get(url);
  return res.data;
};
export const addMaintenanceLog = async (payload) => {
  const res = await api.post("/apis/leak_maintenance", payload);
  return res.data;
};
export const deleteMaintenanceLog = async (id) => {
  const res = await api.delete(`/apis/leak_maintenance/${id}`);
  return res.data;
};
export const updateMaintenanceLog = async (id, payload) => {
  const res = await api.put(`/apis/leak_maintenance/${id}`, payload);
  return res.data;
};
//Temp log API
export const getTempMeterLogs = async (page = 1, perPage = 5, filters = {}) => {
  let url = `/apis/temp_meter?page=${page}&per_page=${perPage}`;

  if (filters.option) {
    url += `&option=${filters.option}`;
  }

  if (filters.start_date && filters.end_date) {
    url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
  }

  const res = await api.get(url);
  return res.data;
};
// ADD TEMP METER
export const addTempMeterLog = async (payload) => {
  const res = await api.post("/apis/temp_meter", payload);
  return res.data;
};

// UPDATE TEMP METER
export const updateTempMeterLog = async (id, payload) => {
  const res = await api.put(`/apis/temp_meter/${id}`, payload);
  return res.data;
};

// DELETE TEMP METER
export const deleteTempMeterLog = async (id) => {
  const res = await api.delete(`/apis/temp_meter/${id}`);
  return res.data;
};

//Drag and drop Home
export const getWidgetLayout = async () => {
  const res = await api.get("/apis/get_widget");
  return res.data;
};

export const editWidgetLayout = async (payload) => {
  const res = await api.put("/apis/edit_widget", payload);
  return res.data;
};
/**
 * Fetch the details and recent daily usage of specific meters (the dashboard's
 * meter pop-up)
 * @param {Array} meterIds - meter ids, at most 25 per call
 * @param {number} days - length of the daily usage series, 1-90
 */
export const getMeterDetail = async (meterIds, days = 30) => {
  const res = await api.get("apis/meter_detail", {
    params: { meter_id: meterIds.join(","), days },
  });
  return res.data; // { data: { status, usage_start, usage_end, days, meters: [ { ...details, usage: [ { date, flow } ] } ] } }
};

// Digital Twin's Historical view: a past day's alerts (date "YYYY-MM-DD"), or
// with none, the dates there is data for.
export const getAlertHistory = async (date = null) => {
  const res = await api.get("apis/alert_history", { params: date ? { date } : {} });
  return res.data; // { status, available: { from, leak, anomaly, flow_health, readings }, date?, start?, hours?, data_until?, price_per_kgal?, leak?, anomaly?, backflow?, no_recent_flow?, system_health? }
};

export const getMeterLocationList = async (active) => {
  const res = await api.get("apis/meter_location_list", {
    params: {
      active: active,
    },
  });
  return res.data;
};
// edit account override name
// ✅ EDIT OVERRIDE NAME
export const editOverrideName = async (id, data) => {
  try {
    const res = await api.patch(`apis/account/overide_name/edit/${id}`, data);
    console.log("Edit Override Name Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error editing override name:", error);
    throw error;
  }
};
/**
 * Fetch combined list of accounts, meters, and categories
 */
// services/index.js

export const toScopeArray = (value) => {
  if (Array.isArray(value)) {
    return value.filter(
      (item) =>
        item !== undefined && item !== null && item !== "" && item !== "All",
    );
  }

  if (!value || value === "All") return [];

  return [value];
};

/** Always return a list for system/plant payloads (never "All" or a bare string). */
export const toScopeListPayload = (value) => toScopeArray(value);

export const toScopePayload = (value) => {
  return toScopeListPayload(value);
};

const buildWaterUsagePayload = (filters = {}) => {
  const OPTION_MAPPING = {
    D: "Past Day",
    W: "Past Week",
    "1M": "Past Month",
    "3M": "Past 3 Months",
    YTD: "Custom",
    "1Y": "Past Year",
  };

  const normalizeInterval = (interval) => {
    if (interval === "Hour" || interval === "Hours") return "Hours";
    if (interval === "Day" || interval === "Days") return "Days";
    if (interval === "Week" || interval === "Weeks") return "Weeks";
    return "Days";
  };

  const isCustom =
    filters.option === "Custom" ||
    filters.mode === "Custom" ||
    filters.chip === "YTD";

  const payload = {
    accounts: filters.accounts || filters.account || [],
    account_ids: filters.account_ids || filters.accountId || [],
    meter_ids: filters.meter_ids || filters.meter || [],
    codes: filters.codes || filters.category || [],
    option: isCustom
      ? "Custom"
      : filters.option || OPTION_MAPPING[filters.chip] || "Past Month",
    interval: normalizeInterval(filters.interval),
    meter_status: filters.meter_status || "active",
    system: toScopePayload(filters.system),
    plant: toScopePayload(filters.plant),
  };

  if (isCustom) {
    payload.start_date = filters.start_date || filters.start;
    payload.end_date = filters.end_date || filters.end;
  }

  return payload;
};

export const getAccountMeterCategoryList = async (payload = {}) => {
  // Ensure the body has the structure the API expects, even if empty
  const body = {
    accounts: payload.accounts || [],
    account_ids: payload.account_ids || payload.accountId || [],
    meter_ids: payload.meter_ids || [],
    codes: payload.codes || [],
    meter_status: payload.meter_status || "active",
    system: toScopePayload(payload.system),
    plant: toScopePayload(payload.plant),
  };

  // Pass 'body' as the second argument to api.post
  const res = await api.post("apis/account_meter_category_list", body);
  return res.data;
};

export const getAccountMeterCategoryListNew = async (payload = {}) => {
  const body = {
    accounts: payload.accounts || [],
    account_ids: payload.account_ids || payload.accountId || [],
    meter_ids: payload.meter_ids || [],
    codes: payload.codes || [],
    meter_status: payload.meter_status || "active",
    system: toScopePayload(payload.system),
    plant: toScopePayload(payload.plant),
  };

  const res = await api.post("apis/account_meter_category_list_new", body);
  return res.data;
};

export const getWaterUsageKPI = async (filters = {}) => {
  const payload = {
    accounts: filters.accounts || filters.accounts || [],
    account_ids: filters.account_ids || filters.account_ids || [],
    meter_ids: filters.meter_ids || [],
    codes: filters.codes || [],
    option: filters.option || "Past Month",
    interval: filters.interval === "Day" ? "Days" : filters.interval || "Days",
    meter_status: filters.meter_status || "active",
    system: toScopePayload(filters.system),
    plant: toScopePayload(filters.plant),
  };

  if (filters.option === "Custom") {
    payload.start_date = filters.start_date;
    payload.end_date = filters.end_date;
  }

  const res = await api.post("/apis/water/usage_kpi_new", payload);

  return res.data;
};

/**
 * Fetch Ranked Meters by Flow
 */

// export const getMetersByFlow = async (filters = {}) => {
//   const payload = buildWaterUsagePayload(filters);

//   const res = await api.post("/apis/water/meter_by_flow", payload);
//   return res.data;
// };
// Inside your services/index.js file
export const getMetersByFlow = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);

  // MANUALLY ATTACH THE TOGGLE PARAMETER HERE BEFORE SENDING
  if (filters.meter_all !== undefined) {
    payload.meter_all = filters.meter_all;
  }

  const res = await api.post("/apis/water/meter_by_flow", payload);
  return res.data;
};
export const getDailyHourlyTrend = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);

  const res = await api.post("/apis/water/usage/trend_analytics", payload);
  return res.data;
};


export const getDailyHourlyTrendData = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);
  // Endpoint: /apis/water/usage/trend_analytics/daily_hourly
  const res = await api.post(
    "/apis/water/usage/trend_analytics/daily_hourly",
    payload,
  );
  return res.data;
};

export const getWeeklyTrendData = async (filters = {}) => {
  const payload = {
    ...buildWaterUsagePayload(filters),
    res_format: "only_daily", // Hardcoded payload requirement for weekly
  };
  // Endpoint: /apis/water/usage/trend_analytics/weekly
  const res = await api.post(
    "/apis/water/usage/trend_analytics/weekly",
    payload,
  );
  return res.data;
};
/**
 * Fetch Historical Max and Year-over-Year data
 * @param {Object} filters - Filter object containing accounts, meter_ids, codes, etc.
 */
export const getWeeklyTrendHistorical = async (filters = {}) => {
  const payload = {
    accounts: filters.accounts || filters.account || [],
    meter_ids: filters.meter_ids || filters.meter || [],
    codes: filters.codes || filters.category || [],
    plant: toScopePayload(filters.plant),
    option: filters.option || "Past Month",
    interval: "Days",
    res_format: "only_daily", // Required as per your requirement
  };

  if (payload.option === "Custom") {
    payload.start_date = filters.start_date || filters.start;
    payload.end_date = filters.end_date || filters.end;
  }

  const res = await api.post("/apis/water/usage/trend_analytics/weekly/historical", payload);
  return res.data;
};

export const getWaterUsageBreakdown = async (filters = {}) => {
  const payload = {
    accounts: filters.accounts || filters.account_ids || [],
    account_ids: filters.account_ids || filters.accountId || [],
    meter_ids: filters.meter_ids || [],
    codes: filters.codes || [],
    option: filters.option || "Past Month",
    interval:
      filters.interval === "Day"
        ? "Days"
        : filters.interval === "Hour"
          ? "Hours"
          : filters.interval === "Week"
            ? "Weeks"
            : filters.interval || "Days",
    meter_status: filters.meter_status || "active",
    system: toScopePayload(filters.system),
    plant: toScopePayload(filters.plant),
  };

  if (payload.option === "Custom") {
    payload.start_date = filters.start_date;
    payload.end_date = filters.end_date;
  }

  const res = await api.post("/apis/water/usage_breakdown_new", payload);

  return res.data;
};

export const getWaterUsageTrendPlots = async (payload = {}) => {
  const body = {
    ...payload,
    meter_status: payload.meter_status || "active",
  };

  const response = await api.post("/apis/water/usage/trend_plots", body);
  return response;
};

// Drought Dashboard Services

export const getDroughtSummary = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/summary", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtTopOffenders = async () => {
  const res = await api.get("/apis/drought/top-offenders");
  return res.data;
};

export const getDroughtViolationsByDay = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/violations-by-day", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtViolationsByHour = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/violations-by-hour", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtRateCodeSplit = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/rate-code-split", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtIrrigationImpact = async ({ from_date, to_date }) => {
  const response = await api.get("/apis/drought/irrigation-impact", {
    params: {
      from_date,
      to_date,
    },
  });

  return response.data;
};

export const getDroughtRecentEvents = (params) => {
  return api.get("/apis/drought/recent-events", { params });
};

export const getDroughtMapLocations = (params) => {
  return api.get("/apis/drought/map-locations", { params });
};

export const getDroughtTrendAnalysis = async (range) => {
  const response = await api.get("/apis/drought/trend-analysis", {
    params: { range },
  });

  return response.data;
};

export const getNewMeterList = async () => {
   return api.get("/apis/meter_new_list");
};
export const getCustomWeeklyTrend = async (payload) => {
  const res = await api.post("/apis/water/usage/trend_analytics/custom_weekly", payload);
  return res.data;
};

export const getSchedulerTimeline = async () => {
  const res = await api.get("/apis/SchedulerTimeline");
  return res.data;
};

export const getDroughtViolationDetail = async (violationId) => {
  const res = await api.get(`/apis/drought/violations/${violationId}`);
  return res.data; // { status, data: { violation_id, property, meter, offense_summary, event_analysis, flow_profile, violation_history } }
};

// Drought Rule Configuration Services

export const getDroughtRules = async () => {
  const res = await api.get("/apis/drought/rules");
  return res.data;
};

export const getDroughtRule = async (ruleId) => {
  const res = await api.get(`/apis/drought/rules/${ruleId}`);
  return res.data; // { status, data: { ...rule } } - allowed days come back as "Mon".."Sun"
};

// Rule body: name, flow_threshold_gph, min_duration_minutes, warning_limit,
// even/odd_allowed_days (1 = Monday .. 7 = Sunday) and even/odd_start_time,
// even/odd_end_time ("HH:mm"). Every field is required.
export const createDroughtRule = async (payload) => {
  const res = await api.post("/apis/drought/rules", payload);
  return res.data;
};

export const updateDroughtRule = async (ruleId, payload) => {
  const res = await api.put(`/apis/drought/rules/${ruleId}`, payload);
  return res.data;
};

// Makes this the one active rule; whichever was active becomes inactive.
export const activateDroughtRule = async (ruleId) => {
  const res = await api.post(`/apis/drought/rules/${ruleId}/activate`);
  return res.data;
};

// status: "active" | "inactive" | "draft"
export const setDroughtRuleStatus = async (ruleId, status) => {
  const res = await api.put(`/apis/drought/rules/${ruleId}/status`, { status });
  return res.data;
};

export const getDroughtGlobalRestrictions = async () => {
  const res = await api.get("/apis/drought/global-restrictions");
  return res.data; // { status, data: { rule_id, name, restricted_start, restricted_end, restricted_days } | null }
};

export const saveDroughtGlobalRestrictions = async (payload) => {
  const res = await api.put("/apis/drought/global-restrictions", payload);
  return res.data;
};

export const getDroughtPenalties = async () => {
  const res = await api.get("/apis/drought/penalties");
  return res.data; // { status, data: [ { id, name, rate_code, penalty_amount, effective_from, effective_to } ] }
};

// One entry per rate code whose amount is changing.
export const saveDroughtPenalties = async (penalties) => {
  const res = await api.put("/apis/drought/penalties", penalties);
  return res.data;
};

// Drought Exemption Services

export const getDroughtExemptions = async ({ search, status, type } = {}) => {
  const res = await api.get("/apis/drought/exemptions", {
    params: {
      search: search || undefined,
      status: status || undefined,
      type: type || undefined,
    },
  });
  return res.data; // { status, data: [ { id, meter_id, address, exemption_type, start_date, end_date, status, notes, document_url } ] }
};

export const getDroughtExemptionStats = async () => {
  const res = await api.get("/apis/drought/exemptions/stats");
  return res.data; // { status, data: { active_count, recent_increase, projected_water_volume } }
};

export const createDroughtExemption = async (payload) => {
  const res = await api.post("/apis/drought/exemptions", payload);
  return res.data;
};

export const updateDroughtExemption = async (exemptionId, payload) => {
  const res = await api.put(`/apis/drought/exemptions/${exemptionId}`, payload);
  return res.data;
};

export const setDroughtExemptionStatus = async (exemptionId, status) => {
  const res = await api.put(`/apis/drought/exemptions/${exemptionId}/status`, { status });
  return res.data;
};
// ===========================================================================
// Reports & Alerts (redesigned page) — saved reports, generic export,
// accountability alarms + alert feed. Backed by ReportsAlertsStubs.py.
// The `api` instance injects Authorization + District automatically.
// ===========================================================================

// ---- Saved reports (My Reports) ----
export const getReports = async () => {
  const res = await api.get("/apis/reports");
  return res.data; // { status, data: [ ...report ] }
};

export const createReport = async (body) => {
  const res = await api.post("/apis/reports", body);
  return res.data;
};

export const updateReport = async (id, body) => {
  const res = await api.put(`/apis/reports/${id}`, body);
  return res.data;
};

export const setReportStatus = async (id, status) => {
  const res = await api.patch(`/apis/reports/${id}`, { status });
  return res.data;
};

export const deleteReport = async (id) => {
  const res = await api.delete(`/apis/reports/${id}`);
  return res.data;
};

export const runReport = async (id) => {
  const res = await api.post(`/apis/reports/${id}/run`);
  return res.data;
};

export const duplicateReport = async (id) => {
  const res = await api.post(`/apis/reports/${id}/duplicate`);
  return res.data;
};

// Generic export. `params` carries source-specific query args that the reused
// readers need (Accountability: system/option/interval/number/start_date/end_date;
// Capacity: unit). Returns a Blob for download.
export const generateReport = async (body, params = {}) => {
  const res = await api.post("/apis/reports/generate", body, {
    params,
    responseType: "blob",
  });
  return res; // caller reads res.data (Blob) + res.headers
};

// ---- Accountability alarms + alert feed ----
export const getAlarms = async () => {
  const res = await api.get("/apis/accountability_alarms");
  return res.data; // { status, data: [ ...alarm ], active_count }
};

export const createAlarm = async (body) => {
  const res = await api.post("/apis/accountability_alarms", body);
  return res.data;
};

export const updateAlarm = async (id, body) => {
  const res = await api.put(`/apis/accountability_alarms/${id}`, body);
  return res.data;
};

export const toggleAlarm = async (id, enabled) => {
  const res = await api.patch(`/apis/accountability_alarms/${id}`, { enabled });
  return res.data;
};

export const deleteAlarm = async (id) => {
  const res = await api.delete(`/apis/accountability_alarms/${id}`);
  return res.data;
};

export const getAccountabilityAlerts = async (limit = 20) => {
  const res = await api.get("/apis/accountability_alarms/alerts", {
    params: { limit },
  });
  return res.data; // { status, data: [ ...alert ] }
};

// ===========================================================================
// Capacity Planning — plant summary, commitments, daily usage.
// Backed by CapacityPlanningResource.py. Values come back in GPD (matching
// the DB schema); CapacityPlanningPage.jsx converts to MGD for display.
// ===========================================================================

// Every Capacity Planning endpoint responds {"data": {...actual fields...}},
// so res.data (below) is that whole envelope - callers read result.data.___.
// `days` on these three makes the page's time-range chip a genuinely global
// filter: actual usage, per-customer utilisation and the alert bands all
// describe the selected period rather than a fixed window or all history.
// `interval` is FlowResource.py's vocabulary - "Past Month", "Past 3 Months",
// "Past 6 Months", "Past Year", plus "YTD". The window is calendar-relative and
// resolved server-side, anchored on the last COMPLETE day of usage. The older
// numeric `days` param is still accepted by the API for existing callers.
// interval="Custom" is the only mode where the backend reads start_date and
// end_date, so every capacity endpoint has to send them or it silently falls
// back to averaging over ALL history - which looks like "the filter did
// nothing" rather than like an error.
const customWindow = (interval, range) => {
  if (interval === "Custom") {
    return { start_date: range?.start || undefined, end_date: range?.end || undefined };
  }
  // YTD is sent as explicit dates, exactly as the Water Usage page sends it
  // (chipToRange in WaterUsageFilters): 1 January to YESTERDAY by the calendar.
  // Resolved on the server instead, it ended on the last complete day in the
  // data - a day earlier whenever yesterday's readings were already in - so the
  // two pages' YTD totals differed by one day's water. `interval` is overridden
  // here, which works because every caller spreads this AFTER its own.
  if (interval === "YTD") {
    const end = dayjs().subtract(1, "day");
    return {
      interval: "Custom",
      start_date: end.startOf("year").format("YYYY-MM-DD"),
      end_date: end.format("YYYY-MM-DD"),
    };
  }
  return {};
};

export const getCapacityPlants = async (interval, range = null) => {
  const res = await api.get("/apis/capacity_planning/plants", {
    params: { interval, ...customWindow(interval, range) },
  });
  return res.data; // { data: { status, usage_as_of, usage_window_start, usage_window_days, plants: [ ... ] } }
};

export const getCapacityCommitments = async (plantKey, search = "", interval, range = null) => {
  const res = await api.get("/apis/capacity_planning/commitments", {
    params: {
      plant: plantKey && plantKey !== "all" ? plantKey : undefined,
      search: search || undefined,
      interval,
      ...customWindow(interval, range),
    },
  });
  return res.data; // { data: { status, count, records: [ ... ] } }
};

export const addCapacityCommitment = async (payload) => {
  const res = await api.post("/apis/capacity_planning/commitments", payload);
  return res.data; // { data: { status, id, account_id, message } }
};

// `accountId` narrows the series to a single billing account (one of the
// account_id values the commitments endpoint returns), so the Plant Usage card
// can be read account-wise. Omitted, the response is the plant-wide sum.
// The register edits commitments in place. A PUT patches only the fields it
// carries, so one cell can be saved without shipping the whole row back.
export const updateCapacityCommitment = async (commitmentId, payload) => {
  const res = await api.put(`/apis/capacity_planning/commitments/${commitmentId}`, payload);
  return res.data; // { data: { status, id, updated, message } }
};

// Withdraw: deletes the row rather than flagging it. "Expired" already means a
// commitment that ran its term, so the two are kept distinct.
export const deleteCapacityCommitment = async (commitmentId) => {
  const res = await api.delete(`/apis/capacity_planning/commitments/${commitmentId}`);
  return res.data; // { data: { status, id, message } }
};

export const getCapacityDailyUsage = async (
  plantKey,
  interval = "Past Month",
  accountId,
  range = null,
  // "hour" asks for an hourly series from flow_data instead of the stored
  // daily table. Honoured only over a short window - the response says which
  // bucket it actually drew.
  bucket = "day",
) => {
  const res = await api.get("/apis/capacity_planning/daily_usage", {
    params: {
      plant: plantKey && plantKey !== "all" ? plantKey : undefined,
      account: accountId && accountId !== "all" ? accountId : undefined,
      interval,
      bucket: bucket === "hour" ? "hour" : undefined,
      ...customWindow(interval, range),
    },
  });
  return res.data; // { data: { status, records, avg_daily_gpd, peak_usage_gpd, peak_date, rolling_30_day_gpd } }
};

// Potable vs reclaimed share of ACTUAL usage over the selected time range.
// The split comes from the meters' service class, so it answers a different
// question than the commitment columns do - see CapacityPlanningResource.py.
// `range` carries explicit dates for interval="Custom" - the backend's
// _resolve_window reads start_date/end_date only in that mode.
// `beyond` asks for the district-wide production / uncommitted block. It is the
// same answer whichever plant is requested and costs a scan of flow_data, so
// exactly ONE caller per page load should ask for it.
export const getCapacityWaterSplit = async (
  plantKey,
  interval = "Past Month",
  range = null,
  { beyond = false, bucket } = {},
) => {
  const res = await api.get("/apis/capacity_planning/water_split", {
    params: {
      plant: plantKey && plantKey !== "all" ? plantKey : undefined,
      interval,
      ...(beyond ? { beyond: 1 } : {}),
      // Only "hour" is a request the API acts on, and only within its own
      // 31-day cap - it answers with the bucket it actually served.
      ...(bucket === "hour" ? { bucket: "hour" } : {}),
      ...customWindow(interval, range),
    },
  });
  return res.data; // { data: { status, as_of, days, potable_gpd, reclaimed_gpd, other_gpd, records } }
};

// Two series against plant supply: metered usage backwards, and committed
// volume forwards as the construction pipeline reaches its effective dates.
// Usage itself is not extrapolated - see CapacityPlanningResource.py.
export const getCapacityTrend = async (plantKey, months = 24, forecastMonths = 36) => {
  const res = await api.get("/apis/capacity_planning/trend", {
    params: {
      plant: plantKey && plantKey !== "all" ? plantKey : undefined,
      months,
      forecast_months: forecastMonths,
    },
  });
  // { data: { status, supply_gpd, months, records, forecast_months,
  //           committed_now_gpd, pipeline_gpd, pipeline, forecast } }
  return res.data;
};

// The editable plant model behind the Plant Capacity tab: TCEQ design
// criteria, policy limits, the emergency tie, and each plant's physical
// elements with any per-element overrides. Capacity is derived from these
// rather than stored, so this is the whole input set in one response.
export const getCapacityPlantModel = async () => {
  const res = await api.get("/apis/capacity_planning/plant_model");
  // { data: { status, migrated, criteria, policy, emergency, plants: [...] } }
  return res.data;
};

// Partial saves are fine: a payload with only { criteria } leaves the plants
// alone, so one card can be saved without shipping the rest of the model.
export const saveCapacityPlantModel = async (payload) => {
  const res = await api.put("/apis/capacity_planning/plant_model", payload);
  return res.data; // { data: { status, message } }
};

export const getCapacityInsights = async (plantKey, interval, range = null) => {
  const res = await api.get("/apis/capacity_planning/insights", {
    params: {
      plant: plantKey && plantKey !== "all" ? plantKey : undefined,
      interval,
      ...customWindow(interval, range),
    },
  });
  // { data: { status, critical, warnings, informational, min_days, window_days, items } }
  return res.data;
};